/**
 * Downloadable resource row.
 */
import React from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";

import { VText, VButton } from "form";
import { BThumb } from "components";

/**
 * File row with a download link.
 *
 * @param {{ item: Object }} props
 */
const CourseDownloadItem = (props) => {
  const { item } = props;

  return (
    <Box className={`border border-solid border-2 rounded-md relative border-gray-200 dark:border-gray-500 h-full`}>
      <a href={item.href} download target="_blank" rel="noreferrer">
        <VButton className="absolute top-2 right-2" iconOnly>
          <Icon icon="eva:download-fill" />
        </VButton>
      </a>
      <Box className="flex flex-col w-full">
        <BThumb src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/bonus2.png`} error="" className="w-full aspect-[5/3] rounded" />
      </Box>
      <Box className="p-4 flex flex-col">
        <VText className="flex">
          <Icon icon="ep:document" className="text-gray-700 flex-shrink-0" />
          &nbsp;{item.displayName}
        </VText>
      </Box>
    </Box>
  );
};

export default CourseDownloadItem;
